const SIZE_MAP = {
  small: 25,
  medium: 35,
  large: 50
}

export default ({ fillColor = '#F6F6F6', strokeColor = '#DCDCDC', style = {}, size = 'large' }) => {
  const pixelSize = SIZE_MAP[size] || SIZE_MAP.large
  return (
    <svg
      width={pixelSize}
      height={pixelSize}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <circle cx="25" cy="25" r="24" fill={fillColor} stroke={strokeColor} />
      <circle cx="33.4" cy="17.8" r="2.4" fill={strokeColor} />
      <circle cx="16.5992" cy="17.8" r="2.4" fill={strokeColor} />
      <path d="M13 36V36C20.5542 32.2229 29.4458 32.2229 37 36V36" stroke={strokeColor} strokeWidth="2" />
    </svg>
  )
}
